import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DataGrid } from '@app/styles';
import { _keys, logicalXOR, MUSTNeverHappenException } from '@nu-art/ts-common';
import { ModuleFE_Tag, ModuleFE_Value, ModuleFE_Variable, QJSONViewer } from '@app/hcs-frontend';
import { TS_EditableItemComponentProto } from '@nu-art/thunderstorm-frontend/editable-item';
import { LL_V_L } from '@nu-art/thunderstorm-frontend';
import { resolveValueDisplay } from '@app/hcs-shared';
export class Renderer_ActionData_Uneditable extends TS_EditableItemComponentProto {
    // ######################## Render ########################
    render() {
        return _jsxs(DataGrid.Grid, { className: 'editor__order__uneditables', children: [this.renderMetaData(), this.renderVariableIds(), this.renderResolutionType(), this.renderResolutionFindings(), this.renderResolutionDialog(), this.renderProperties()] });
    }
    renderMetaData = () => {
        const action = this.state.editable.item;
        return _jsxs(_Fragment, { children: [_jsx(DataGrid.Label, { children: "MetaData" }), _jsx(QJSONViewer, { item: action.metadata ?? {} })] });
    };
    renderVariableIds = () => {
        const action = this.state.editable.item;
        return _jsxs(_Fragment, { children: [_jsx(DataGrid.Label, { children: "VariableIds" }), !action.variableIds?.length && _jsx(DataGrid.Data, { children: "-" }), !!action.variableIds?.length && _jsx(LL_V_L, { children: action.variableIds.map(id => {
                        const variable = ModuleFE_Variable.cache.unique(id);
                        if (!variable)
                            throw new MUSTNeverHappenException(`Could not find variable for id ${id}`);
                        return _jsxs(DataGrid.Data, { children: [variable.name, " ", _jsxs("i", { children: ["(", id, ")"] })] }, id);
                    }) })] });
    };
    renderResolutionType = () => {
        const action = this.state.editable.item;
        return _jsxs(_Fragment, { children: [_jsx(DataGrid.Label, { children: "Resolution Type" }), _jsx(DataGrid.Data, { children: action.resolution ?? '-' })] });
    };
    renderResolutionFindings = () => {
        const action = this.state.editable.item;
        return _jsxs(_Fragment, { children: [_jsx(DataGrid.Label, { children: "Resolution Findings" }), !action.resolutionFindings?.length && _jsx(DataGrid.Data, { children: "-" }), !!action.resolutionFindings?.length && _jsx(LL_V_L, { children: action.resolutionFindings.map(finding => {
                        const variable = ModuleFE_Variable.cache.unique(finding.variableId);
                        if (!variable)
                            throw new MUSTNeverHappenException(`Could not find variable for id ${finding.variableId}`);
                        const value = ModuleFE_Value.cache.unique(finding.valueId);
                        if (!value)
                            throw new MUSTNeverHappenException(`Could not find variable for id ${finding.valueId}`);
                        return _jsxs(LL_V_L, { children: [_jsxs(DataGrid.Data, { children: ["Variable: ", variable.name] }), _jsxs(DataGrid.Data, { children: ["Value: ", resolveValueDisplay(value)] })] }, `${finding.variableId}-${finding.valueId}`);
                    }) })] });
    };
    renderResolutionDialog = () => {
        const action = this.state.editable.item;
        return _jsxs(_Fragment, { children: [_jsx(DataGrid.Label, { children: "Resolution Dialog" }), !action.resolutionDialog && _jsx(DataGrid.Data, { children: "-" }), !!action.resolutionDialog &&
                    _jsxs(DataGrid.Data, { children: [action.resolutionDialog.clinicalFormKey, " (", action.resolutionDialog.isOrderSpecific ? '' : 'Not ', "Order Specific)"] })] });
    };
    renderProperties = () => {
        const action = this.state.editable.item;
        return _jsxs(_Fragment, { children: [_jsx(DataGrid.Label, { children: "Properties" }), !action.properties && _jsx(DataGrid.Data, { children: "-" }), !!action.properties && _jsx(LL_V_L, { children: _keys(action.properties).map((key) => {
                        const tag = ModuleFE_Tag.cache.unique(key);
                        const variable = ModuleFE_Variable.cache.unique(key);
                        if (!logicalXOR(!!tag, !!variable)) {
                            if (tag)
                                throw new MUSTNeverHappenException(`id ${key} points to both tag [${tag.label}] and variable [${variable?.name}]`);
                            throw new MUSTNeverHappenException(`id ${key} doesn't point to a tag or variable`);
                        }
                        const valueId = action.properties[key];
                        const value = ModuleFE_Value.cache.unique(valueId);
                        if (!value)
                            throw new MUSTNeverHappenException(`Could not find variable for id ${valueId}`);
                        if (tag)
                            return _jsxs(DataGrid.Data, { children: [tag.label, " (tag) : ", resolveValueDisplay(value), " (value)"] }, key);
                        return _jsxs(DataGrid.Data, { children: [variable?.name, " (variable) : ", resolveValueDisplay(value), " (value)"] }, key);
                    }) })] });
    };
}
//# sourceMappingURL=Renderer_ActionData_Uneditable.js.map